export const routeList = [
    {
        id: "1",
        name: "推荐页",
        path: "/home",
    },
    {
        id: "2",
        name: "新服页",
        path: "/newServer",
    },
    {
        id: "3",
        name: "发现页",
        path: "/discover",
    },
    {
        id: "4",
        name: "排行页",
        path: "/list",
    },
    {
        id: "5",
        name: "个人中心",
        path: "/user",
    },
    {
        id: "6",
        name: "用户主页",
        path: "/otherUser",
    },
    {
        id: "7",
        name: "搜索页",
        path: "/search",
    },
    {
        id: "8",
        name: "我的游戏",
        path: "/allgame",
    },
    {
        id: "10",
        name: "交易行",
        path: "/transaction",
    },
    {
        id: "11",
        name: "任务",
        path: "/task",
    },
    {
        id: "12",
        name: "期待",
        path: "/forward",
    },
    {
        id: "13",
        name: "我的任务",
        path: "/myTask",
    },
    {
        id: "14",
        name: "我的钱包",
        path: "/wallet",
    },
    {
        id: "15",
        name: "信用分",
        path: "/credit",
    },
    {
        id: "16",
        name: "信用分明细",
        path: "/particulars",
    },
    {
        id: "17",
        name: "信用分规则",
        path: "/explan",
    },
    {
        id: "18",
        name: "实名认证",
        path: "/certification",
    },
    {
        id: "19",
        name: "小号管理",
        path: "/lightvehicle",
    },
]
